var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.type,{tag:"component",staticClass:"border-b w-full hr",class:_vm.darker ? 'border-theme-darker' : 'border-theme'})
}
var staticRenderFns = []

export { render, staticRenderFns }